import type { Agent } from '../services/api';

interface Props {
  agents: Agent[];
  selected: string;
  onChange: (id: string) => void;
  disabled?: boolean;
}

export function WorkstationPicker({ agents, selected, onChange, disabled }: Props) {
  const selectedAgent = agents.find(a => a.id === selected);
  return (
    <div className="field-group">
      <label className="field-label">Agente</label>
      <select
        className="select"
        value={selected}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
      >
        <option value="">Selecciona un agente…</option>
        {agents.map(a => (
          <option key={a.id} value={a.id}>
            {a.name}
          </option>
        ))}
      </select>
    </div>
  );
}
